export class CountdownTimer {
    constructor(elm, tl) {
        this.elem = elm;
        this.tl = tl;
        this.tid = '';
    }

    newData(tl) {
        this.tl = tl;
    }

    countDown() {
        let timer = '';
        const today = new Date();
        const day = Math.floor((this.tl - today) / (24 * 60 * 60 * 1000));
        const hour = Math.floor(((this.tl - today) % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
        const min = Math.floor(((this.tl - today) % (24 * 60 * 60 * 1000)) / (60 * 1000)) % 60;
        const sec = Math.floor(((this.tl - today) % (24 * 60 * 60 * 1000)) / 1000) % 60 % 60;

        if ((this.tl - today) > 0) {
            timer += `<label class="projector_label">${window.Literals.coundDown.countdownLabel}</label><div>`;
            if (this.addZero(day) > 0)
                timer += `<span class="number-wrapper"><div class="line"></div><div class="caption">${window.Literals.coundDown.countdownDays}</div><span class="number day">${this.addZero(day)}</span></span>`;
            timer += `<span class="number-wrapper"><div class="line"></div><div class="caption">${window.Literals.coundDown.countdownHours}</div><span class="number hour">${this.addZero(hour)}</span></span>`;
            timer += `<span class="number-wrapper"><div class="line"></div><div class="caption">${window.Literals.coundDown.countdownMinutes}</div><span class="number min">${this.addZero(min)}</span></span>`;
            timer += `<span class="number-wrapper"><div class="line"></div><div class="caption">${window.Literals.coundDown.countdownSeconds}</div><span class="number sec">${this.addZero(sec)}</span></span></div>`;

            this.elem.html(timer);

            this.tid = setTimeout(() => {
                this.countDown();
            }, 1000);
        } else {
            clearTimeout(this.tid);
            this.elem.remove();
        }
    }

    addZero(num) {
        return (num.toString().length === 1) ? `0${num}` : num;
    }
}